import { IIconProvider, IStatusProvider } from '@absg/angular-components';
import { DateTimeHelper } from '@absg/angular-platform';
import { PatientLite } from '@absg/api-party';
import { ContainerTypes, IAccessPoint, StoragePosition } from '@absg/nim-client-shared';
import { ParentComponentTypes } from 'shared.root/enums/parentcomponent.enum';
import { CheckPracticeOwnedStatusPillHelper } from 'shared.root/helpers/status-pill.helper';

export class WitnessItem implements IStatusProvider, IIconProvider, IAccessPoint {
  doorName?: string;
  positionName?: string;
  displayName?: string;
  alternateName?: string;
  genericName?: string;
  gcnSequenceNumber?: string;
  supplierProductInclusionId?: number;
  isPracticeFavorite?: boolean;
  isRefrigerated?: boolean;
  isBinItem = false;
  isWitnessRequired?: boolean;
  isDiscontinued?: boolean;
  userInputQtyInvUnitInCabinet?: number;
  // TODO: Remove this property throughout
  userInputQtyInvUnitInUTH?: number;
  inventoryUnitOfMeasure?: string;
  ndc?: string;
  lotNumber?: string;
  accessPointId?: number;
  // TODO: Remove this property throughout
  qtyOnHandInUTH?: number;
  qtyOnHandInCabinet?: number;
  reqDispenseUnitAdministerQuantity?: number;
  allowedReqAdministerQuantity?: number;
  notes?: string;
  parentComponent?: ParentComponentTypes;
  skipTransaction: boolean;
  transactionFail?: boolean;
  volumeUnitOfMeasureConversionFactor?: number;
  inventoryUnitOfMeasureConversionFactor?: number;
  dispenseUnitOfMeasureConversionFactor?: number;
  purchaseUnitOfMeasureConversionFactor?: number;
  inventoryItemId?: number;
  lotExpirationDate?: Date;
  itemId?: string;
  positionContainerId?: number;
  witnessUserPartyId?: number;
  witnessUserFullName?: string;
  isMultiLotYN?: boolean;
  isLotTracking?: boolean;
  formularyTypeId?: number;
  isInSufficientQtyReq = false;
  isAssigned: boolean;
  storagePosition: StoragePosition;
  isPreferredNdc?: boolean;
  autoReorderspInclusionId?: number;
  autoReorderspItemId?: string;
  autoReorderTradeName?: string;
  productId?: number;
  rowSpan?: number;
  groupIndex?: number;
  itemsCount?: number;
  sapMaterialNumber?: string;
  meiParentId?: number;
  isBuyIn = false;
  is340B = false;
  isPatientOwned = false;
  elementIdString?: string;
  patientInfo?: PatientLite;
  patientOwnedItemTypeShortName: string;
  isItem505b2?: boolean;

  isUnassignedStatus(): boolean {
    return !this.isAssigned;
  }

  isDiscontinuedStatus(): boolean {
    return this.isDiscontinued && !this.isPatientOwnedStatus();
  }

  isReturnedStatus(): boolean {
    return false;
  }

  isWastedStatus(): boolean {
    return false;
  }

  isPracticeStatus(): boolean {
    return CheckPracticeOwnedStatusPillHelper.isPracticeOwnedItem(this);
  }

  isInsufficientQuantityStatus(): boolean {
    return this.isInSufficientQtyReq;
  }

  isBuyInStatus(): boolean {
    return this.isBuyIn;
  }
  is340BStatus(): boolean {
    return this.is340B;
  }
  isPatientOwnedStatus(): boolean {
    return this.isPatientOwned;
  }

  isPhysicalDoor(): boolean {
    if (this.storagePosition) {
      return this.storagePosition.isPhysicalPosition;
    } else {
      return false;
    }
  }
  isSimulateModeOn(): boolean {
    if (this.storagePosition) {
      return !!this.storagePosition.isSimulateMode;
    } else {
      return false;
    }
  }

  isLad(): boolean {
    if (this.storagePosition && this.storagePosition.containerType) {
      return this.storagePosition && this.storagePosition.containerType.id === ContainerTypes.LimitedAccessDrawer;
    } else {
      return false;
    }
  }

  getAssociatedAccessPointId(): number {
    if (this.storagePosition) {
      if (this.isLad()) {
        return this.storagePosition.id;
      } else {
        return this.storagePosition.parentContainerId;
      }
    } else {
      return -1;
    }
  }

  getAssociatedAccessPointName(): string {
    if (this.storagePosition) {
      if (this.isLad()) {
        return this.storagePosition.name;
      } else {
        return this.storagePosition.parentContainerName;
      }
    } else {
      return 'Unknown';
    }
  }

  getCabinetName(): string {
    throw new Error('Method not implemented.');
  }

  isItemPracticeFavorite(): boolean {
    return this.isPracticeFavorite;
  }

  isItemRefrigerated(): boolean {
    return this.isRefrigerated;
  }

  isBinned(): boolean {
    return this.isBinItem;
  }

  isFormularyUnAssignedStatus(): boolean {
    return false;
  }

  isFluVaccineStatus(): boolean {
    return false;
  }

  isItem505b2Status(): boolean {
    return this.isItem505b2 ? this.isItem505b2 : false;
  }

  isPracticeUnAssignedStatus(): boolean {
    return false;
  }

  getProductDisplayName(): string {
    return this.isBinned() ? this.genericName : this.displayName;
  }

  getSupplierProductInclusionId(): number {
    return this.isBinned() ? this.meiParentId : this.supplierProductInclusionId;
  }

  getPatientOwnedDemographics(): string {
    let patientOwnedDemographics = '';
    if (this.patientInfo) {
      patientOwnedDemographics =
        `${this.patientInfo.lastName}, ${this.patientInfo.firstName} (${this.patientInfo.idNumber}) ${DateTimeHelper.formatDate(this.patientInfo.birthDate)}`;
    }
    return patientOwnedDemographics;
  }

  getPositionSequence(): number {
    return this.storagePosition.sequence;
  }
}
